import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { Button } from '@estee/elc-buttons';

import classnames from 'classnames';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';

const className = classes('iam-social-sign-up-profile-error-page');

const BackButton = styled(Button)`
    inline-size: auto;
`;

export const ProfileErrorPage = observer(() => {
    const controller = React.useMemo(
        () => diContainer.get(serviceNames.profileErrorPageViewController),
        []
    );

    const { ctaLabel, instructionLabel, errorMessage } = controller.data;

    return (
        <div className={classnames('flex flex-col items-center mt-24 mx-8 gap-6', className)}>
            <p>{errorMessage}</p>
            {history.length > 1 && ctaLabel && (
                <BackButton onClick={() => history.back()}>{ctaLabel}</BackButton>
            )}
            {instructionLabel && <div>{instructionLabel}</div>}
        </div>
    );
});
